const indexData = [
  { label: '最新国产电影', icon: 'ri-film-line', count: '2,856部' },
  { label: '热播国产剧集', icon: 'ri-tv-2-line', count: '1,943部' },
  { label: '网络自制剧', icon: 'ri-computer-line', count: '1,287部' },
  { label: '纪录片专区', icon: 'ri-camera-lens-line', count: '864部' },
  { label: '动画电影', icon: 'ri-paint-brush-line', count: '736部' },
  { label: '经典老片库', icon: 'ri-history-line', count: '2,134部' },
  { label: '动作冒险', icon: 'ri-sword-line', count: '1,562部' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '1,089部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            影视索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型快速浏览片库，找到你最想看的国产影视内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-3 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/50 cursor-pointer transition-colors group"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-base md:text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs md:text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.label}
                </div>
                <div className="text-[11px] md:text-xs text-foreground-400">
                  {item.count}
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-sm"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}